"use client";

import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";

type Method = "post" | "put" | "delete" | "patch";

export function useApiMutation<TData = unknown, TVariables = unknown>({
  url,
  method = "post",
  options,
}: {
  url: string;
  method?: Method;
  options?: UseMutationOptions<TData, unknown, TVariables>;
}) {
  return useMutation<TData, unknown, TVariables>({
    mutationFn: (data: TVariables) => {
      if (method === "delete") {
        return apiClient[method](url);
      }
      return apiClient[method](url, data as Record<string, unknown>);
    },
    ...options,
  });
}
